// extracted by mini-css-extract-plugin
export var hero = "hero-landing-module--hero--d5e4c";
export var wholePageEditButton = "hero-landing-module--wholePageEditButton--4d468";